import { useEffect, useState } from "react";
import { Combobox } from "./ui/combobox";
// import { useGetCustomerNamesQuery } from "../store/api/customerApi";
import { CheckIcon, Layers } from "lucide-react";
import { cn } from "../lib/utils";

const ResourceDropdown = ({}) => {
  // const { data, isLoading, isFetching } = useGetCustomerNamesQuery({});
  const [resources, setResources] = useState([
    {
      label: "i-0a12b34c56d78e910",
      value: "1",
    },
    {
      label: "i-0b98c76d54e32f110",
      value: "2",
    },
  ]);

  // useEffect(() => {
  //   setResources(data?.map(i => ({
  //     label: i.organization,
  //     value: i.id.toString(),
  //     // project: i.project
  //   })));
  // }, [data]);

  return (
    <Combobox
      label="Select Resource"
      classes={{ button: "w-60", popoverContent: "w-60" }}
      data={resources}
      keywords={["label"]}
      icon={<Layers className="w-4" />}
      defaultValue="1"
      renderItem={(item, value) => (
        <>
          <CheckIcon
            className={cn(
              "mr-2 h-4 w-4",
              value === item.value ? "opacity-100" : "opacity-0"
            )}
          />
          <div>
            <div>{item.label}</div>
            <div className="text-xs text-gray-400">{item.organization}</div>
          </div>
        </>
      )}
    />
  );
};

export default ResourceDropdown;
